import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]

  // Flag titles long enough to be worth expanding so they can advertise a
  // pointer cursor; a title that already fits gets no affordance.
  connect() {
    if (this.overflowing) this.textTarget.dataset.clickable = "true"
  }

  // one-way: stays expanded once clicked, even across Turbo navigations
  latch() {
    if (this.element.dataset.expanded) return
    if (!this.overflowing) return
    this.element.dataset.expanded = "true"
    // Nothing left to expand, so drop the pointer affordance.
    delete this.textTarget.dataset.clickable
  }

  get overflowing() {
    return this.textTarget.scrollWidth > this.textTarget.offsetWidth
  }
}
